import { Privacy } from "../types/app";

export const privacyData: { [key: string]: Privacy[] } = {
  zh: [
    {
      title: "信息收集",
      content:
        "我们收集的信息包括您使用我们服务时提供的信息，以及我们通过技术手段自动收集的信息。我们承诺只收集必要的个人信息，并采取适当的安全措施保护您的隐私。",
    },
    {
      title: "信息使用",
      content:
        "我们使用收集的信息来提供、维护和改进我们的服务，包括处理您的请求、发送服务通知、提供客户支持等。我们不会将您的个人信息出售给第三方。",
    },
    {
      title: "信息共享",
      content:
        "除法律要求或获得您的明确同意外，我们不会与第三方共享您的个人信息。在必要时，我们可能会与我们的服务提供商共享信息，但仅限于提供服务所必需的范围。",
    },
    {
      title: "信息安全",
      content:
        "我们采用行业标准的安全措施来保护您的个人信息，包括数据加密、访问控制、安全审计等。我们定期审查和更新我们的安全措施。",
    },
    {
      title: "您的权利",
      content:
        "您有权访问、更正、删除您的个人信息，以及限制或反对我们处理您的个人信息。如需行使这些权利，请联系我们。",
    },
  ],
  en: [
    {
      title: "Information Collection",
      content:
        "The information we collect includes information you provide when using our services, as well as information we automatically collect through technical means. We are committed to collecting only necessary personal information and taking appropriate security measures to protect your privacy.",
    },
    {
      title: "Information Use",
      content:
        "We use the collected information to provide, maintain and improve our services, including processing your requests, sending service notifications, providing customer support, etc. We will not sell your personal information to third parties.",
    },
    {
      title: "Information Sharing",
      content:
        "Except as required by law or with your explicit consent, we will not share your personal information with third parties. When necessary, we may share information with our service providers, but only to the extent necessary to provide services.",
    },
    {
      title: "Information Security",
      content:
        "We adopt industry-standard security measures to protect your personal information, including data encryption, access control, security audits, etc. We regularly review and update our security measures.",
    },
    {
      title: "Your Rights",
      content:
        "You have the right to access, correct, delete your personal information, and restrict or object to our processing of your personal information. If you need to exercise these rights, please contact us.",
    },
  ],
};
